import { useMemo, useCallback, useContext } from 'react';
import { CommonPortalContext } from '../contexts/commonPortal';
// eslint-disable-next-line no-unused-vars
import { NavItems, BottomNavItems, NavKey } from '../components/NavBar';
import { POPUP_TYPE } from '../components/subComponents/popup';
import PPButton from '../components/subComponents/button';
import { IPopup } from '../constants/commonPortal.constant';
// eslint-disable-next-line no-unused-vars
import { CommonConstant } from '../constants/common.constant';

const MockFn = () => {};

/**
 * 
 * @param {{
 *  scheduledVisits: {}[];
 *  asyncOrders: {}[];
 *  tasks: {}[];
 *  items: NavItems;
 *  bottomItems: BottomNavItems;
 *  history: {
 *    push: (path: string) => void;
 *  };
 * }} params 
 * @returns {{
 *  navItems: NavItems;
 *  bottomNavItems: BottomNavItems;
 * }}
 */
export const useNavItems = ({
  scheduledVisits,
  asyncOrders,
  tasks,
  items,
  bottomItems,
  history,
}) => {
  const { handler: { handleFSPopupClose, handleFSPopupOpen } } = useContext(CommonPortalContext);

  const handleVisitLegacy = () => {
    window.open(`${CommonConstant.LEGACY_URL}Patients/MyPatients`, '_self');
  };

  const JumpIntoLegacyAction = useMemo(() => () => (
    <div className='flex align-items-center justify-content-center gap-16'>
      <PPButton
        label='Yes, leave page'
        variant='contained'
        endGutter
        onClick={handleVisitLegacy}
      />
      <PPButton
        label='No, do not'
        variant='cancel'
        onClick={handleFSPopupClose}
      />
    </div>
  ), [handleFSPopupClose]);

  const handleRoute = useCallback((url = '') => {
    history.push(url);
  }, [history]);

  const handleJumpIntoLegacy = useCallback(() => {
    handleFSPopupOpen(IPopup({
      open: true,
      title: 'Are you sure you want to leave this page?',
      type: POPUP_TYPE.INFO,
      message: '',
      content: <JumpIntoLegacyAction />,
      onOk: handleFSPopupClose,
    }));
  }, [handleFSPopupClose, handleFSPopupClose]);

  const navItems = useMemo(() => {
    const nI = items.map((item) => {
      item.onRoute = handleRoute;

      if (item.key === NavKey.home) {
        item.onRoute = MockFn;
      }

      if (item.key === NavKey.ao) {
        item.badgeCount = asyncOrders.length;
      }

      if (item.key === NavKey.sv) {
        item.badgeCount = scheduledVisits.length;
      }

      if (item.key === NavKey.tasks) {
        item.badgeCount = tasks.length;
      }

      if (item.key === NavKey.pcm) {
        item.onRoute = handleJumpIntoLegacy;
      }

      return item;
    });

    return nI;
  }, [scheduledVisits, asyncOrders, tasks, handleRoute, handleJumpIntoLegacy]);

  const bottomNavItems = useMemo(() => {
    const nI = bottomItems.map((item) => {
      item.onRoute = handleRoute;

      return item;
    });
    return nI;
  }, [scheduledVisits, asyncOrders, tasks, handleRoute, handleJumpIntoLegacy]);

  return {
    navItems,
    bottomNavItems,
  };
};

export default useNavItems;
